import httpClient from '../httpClient';


const getSport =  (page,pagesSize) => httpClient.get(`/Sports?page=${1}&pageSize=${1000}`).then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setSport =  (params) => httpClient.post('/Sports', params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putSport = (params,id) => httpClient.put(`/Sports/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteSport= (id) => httpClient.delete(`/Sports/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getSport,
  setSport,
  putSport,
  deleteSport,
  // getUser,
  // createUser
}
